export enum ReducerMethods {
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  CLEAN = 'CLEAN'
};
